import { TrackingEvent } from '../../../Entities/Schema.entity';

import { createAlertStartSchema } from './CreateAlertStartSchema';

export type CreateAlertStartEvent = TrackingEvent<Record<any, any>>;

export const createAlertStartToEvent = (): CreateAlertStartEvent => {
  const event: CreateAlertStartEvent = {
    schema: createAlertStartSchema.ref,
    data: {},
  };

  return event;
};
